module.exports = __webpack_public_path__ + "3d622932923c42d8689bf02015788a87.svg";